(() => {
  if (window.baesicSiteMode) return;
  const root = document.documentElement;
  const motion = window.matchMedia?.('(prefers-reduced-motion: reduce)');
  let active = null;
  let revision = 0;
  const set = (value, animate = false, updateContent = () => {}) => {
    const mode = value === 'night' ? 'night' : 'day';
    const current = ++revision;
    active?.skipTransition();
    active = null;
    delete root.dataset.siteReveal;
    const apply = async () => {
      if (current !== revision) return;
      root.dataset.siteMode = mode;
      await updateContent();
    };
    const duration = parseFloat(getComputedStyle(root).getPropertyValue('--site-mode-duration')) || 0;
    if (!animate || motion?.matches || !document.startViewTransition || duration <= 0 || root.dataset.siteMode === mode) {
      const finished = apply();
      return { updateCallbackDone: finished, finished };
    }
    root.dataset.siteReveal = mode;
    try {
      const transition = document.startViewTransition(apply);
      active = transition;
      transition.ready.catch(() => {});
      transition.updateCallbackDone.catch(() => { apply(); });
      transition.finished.catch(() => {}).finally(() => {
        if (current !== revision) return;
        active = null;
        delete root.dataset.siteReveal;
      });
      return transition;
    } catch {
      const finished = apply();
      delete root.dataset.siteReveal;
      return { updateCallbackDone: finished, finished };
    }
  };
  motion?.addEventListener?.('change', () => { if (motion.matches) active?.skipTransition(); });
  window.addEventListener('pagehide', () => active?.skipTransition());
  window.baesicSiteMode = { set };
})();
(() => {
  if (window.baesicVehicleTouchFeedback) return;
  window.baesicVehicleTouchFeedback = true;
  let pressed = null;
  let start = null;
  const clear = () => {
    pressed?.removeAttribute('data-vehicle-pressed');
    pressed = null;
    start = null;
  };
  document.addEventListener('pointerdown', event => {
    clear();
    if (event.pointerType !== 'touch' && event.pointerType !== 'pen') return;
    const link = event.target.closest?.('a.collection-card, .chassis-card a.button');
    const card = link?.closest('.collection-card');
    if (!card?.closest('.regional-makes, .nav-catalog') || link.getAttribute('aria-disabled') === 'true') return;
    pressed = card;
    start = { x: event.clientX, y: event.clientY, id: event.pointerId };
    card.setAttribute('data-vehicle-pressed', '');
  }, { passive: true });
  document.addEventListener('pointermove', event => {
    if (start && (event.pointerId !== start.id || Math.hypot(event.clientX - start.x, event.clientY - start.y) > 10)) clear();
  }, { passive: true });
  for (const name of ['pointerup', 'pointercancel', 'dragstart', 'shopify:section:unload']) document.addEventListener(name, clear, { passive: true });
  document.addEventListener('scroll', clear, { passive: true, capture: true });
  window.addEventListener('pagehide', clear);
  window.addEventListener('blur', clear);
})();

